import { render, staticRenderFns } from "./EconomiaCircular.vue?vue&type=template&id=58c98d96&scoped=true&"
import script from "./EconomiaCircular.vue?vue&type=script&lang=js&"
export * from "./EconomiaCircular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c98d96",
  null
  
)

export default component.exports